export default `
    <li
        # if (data.id) { # id="#= data.prefix || "" ##= data.id #_LI" # } #
        # if (data.classes) { # class="#= data.classes # #=data.bsc||""#" # } #
        # if (data["data-id"]) { # data-id="#= data["data-id"] #" # } #
        data-expanded="#= data.expanded || "false" #" 
        # if (data.expands) { # data-expands="#= data.expands #" # } #
        # if (data.dataValue) { # data-value="#= data.dataValue #" # } #
        # if (data.dataSubValue) { # data-sub-value="#= data.dataSubValue #" # } #
        # if (data.labelBind) { # title="#= data.labelBind #" # } #
    >
        #= data.labelBind #
        # if (data.listItems) { # #= data.listItems # # }#
    </li>
`;
